export default __webpack_public_path__ + "media/ZeeMedia.22f3ea06.svg";